<template>
  <div>
    <dui-form
      ref="form"
      is-dialog
      :title="
        $helpers.translateKeyContent(
          'QoalaExternalDashboardGadget',
          'Customise Navigation',
        )
      "
      :on-submit="onSubmit"
      :cancel-wording="
        $helpers.translateKeyContent('QoalaExternalDashboardGadget', 'Cancel')
      "
      :submit-wording="
        $helpers.translateKeyContent('QoalaExternalDashboardGadget', 'Done')
      "
      :max-width="400"
      :submitFormDispatchFn="$helpers.submitFormDispatchFn"
      :submitFormErrorFn="$helpers.submitFormErrorFn"
      @close-form="formOnClosed"
    >
      <template #formBody>
        <dui-draggable
          v-model="navData"
          class="draggable-customise-navigation"
        />
      </template>

      <template #formAction>
        <a class="reset-btn" @click="reset">
          {{
            $helpers.translateKeyContent(
              "QoalaExternalDashboardGadget",
              "Reset to Default",
            )
          }}
        </a>
      </template>
    </dui-form>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";

import * as drawerIcons from "@/shared/constants/drawerIcons.constant";

export default {
  name: "CustomiseNavigation",

  data() {
    return {
      navData: [],
      menuIcons: drawerIcons,
    };
  },

  computed: {
    computedData() {
      // later fetch from vuex
      let tempPersist =
        this.$store.getters["appPersisted/getSidebarMenu"] !== ""
          ? JSON.parse(this.$store.getters["appPersisted/getSidebarMenu"])
          : [];

      // sidebarMenu persist is empty
      if (!tempPersist.length) {
        // get it from default
        const tempPersistDefault =
          this.$store.getters["appPersisted/getSidebarMenuDefault"] !== ""
            ? JSON.parse(
                this.$store.getters["appPersisted/getSidebarMenuDefault"],
              )
            : [];

        tempPersist = cloneDeep(tempPersistDefault);
      }

      let result = [
        {
          id: 1,
          name: "Dashboard",
          icon: this.menuIcons.mdiViewDashboard,
          items: [
            {
              id: 11,
              name: "Policy List",
            },
            {
              id: 12,
              name: "Claim List",
            },
          ],
        },
        {
          id: 2,
          name: "Life Insurance",
          icon: this.menuIcons.mdiHeartPulse,
        },
        {
          id: 3,
          name: "Access Management",
          icon: this.menuIcons.mdiAccountMultiplePlus,
        },
      ];

      if (tempPersist.length) {
        // result = _map(tempPersist, (item, index) => ({
        //     id: index,
        //     name: item.name,
        //     text: item.title,
        //     icon: item.icon,

        //     ...(typeof item.items !== 'undefined' && item.items.length) && {
        //         items: _map(item.items, (childItem, childIndex) => ({
        //             id: `${index}${childIndex}`,
        //             name: childItem.name,
        //             text: childItem.title,
        //             icon: childItem.icon
        //         }))
        //     }
        // }));

        result = cloneDeep(tempPersist);
      }

      // make sure the icons are in mdi js coordinate form
      const items = this.modifyItemsIcon(result);
      return items.map((item) => {
        const modifedItem = {
          ...item,
          text: this.$helpers.translateKeyContent(
            "QoalaExternalDashboardGadget",
            item.text,
          ),
        };

        if (item?.items) {
          modifedItem.items = item.items.map((i) => {
            return {
              ...i,
              text: this.$helpers.translateKeyContent(
                "QoalaExternalDashboardGadget",
                i.text,
              ),
            };
          });
        }

        return modifedItem;
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.navData = [...this.computedData];
    }, 1000);
  },

  methods: {
    openModal() {
      this.$refs.form.toggleModal = true;
    },

    modifyItemsIcon(items) {
      items.map((dataItem) => {
        if (dataItem.items) {
          this.modifyItemsIcon(dataItem.items);
        }
        return (dataItem.icon = this.generateIcons(dataItem.icon));
      });
      return items;
    },

    generateIcons(iconName) {
      for (const icon in this.menuIcons) {
        if (iconName === icon) {
          return this.menuIcons[iconName];
        }
      }
      return iconName;
    },

    async onSubmit() {
      try {
        // set sidebarMenu from sidebarMenuDefault
        this.$store.dispatch(
          "appPersisted/setSidebarMenu",
          JSON.stringify(this.navData),
        );

        // success notification
        this.$store.dispatch("app/toggleSnackBar", {
          message: `<b>Well done!</b> Navigation updated`,
          color: "invert-success",
        });
      } catch (error) {
        // error notification
        this.$store.dispatch("app/toggleSnackBar", {
          message: `<b>Error!</b> Fail to update navigation: ${error.message}`,
          color: "invert-error",
        });
      }

      // reset data

      // refresh
      this.$emit("refresh", {});
    },

    reset() {
      // reset sidebarMenu to default
      const tempPersistDefault =
        this.$store.getters["appPersisted/getSidebarMenuDefault"] !== ""
          ? JSON.parse(
              this.$store.getters["appPersisted/getSidebarMenuDefault"],
            )
          : [];

      // set navData (for customiseNavigation content)
      this.navData = cloneDeep(tempPersistDefault);

      // scroll to top
      // https://github.com/vuetifyjs/vuetify/issues/1687#issuecomment-508749898
      if (
        typeof document.getElementsByClassName(
          "draggable-customise-navigation",
        )[0] !== "undefined"
      ) {
        document.getElementsByClassName(
          "draggable-customise-navigation",
        )[0].scrollTop = 0;
      }
    },

    formOnClosed() {
      this.navData = [...this.computedData];

      // scroll to top
      // https://github.com/vuetifyjs/vuetify/issues/1687#issuecomment-508749898
      if (
        typeof document.getElementsByClassName(
          "draggable-customise-navigation",
        )[0] !== "undefined"
      ) {
        document.getElementsByClassName(
          "draggable-customise-navigation",
        )[0].scrollTop = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-btn {
  margin-bottom: 18px;
  display: block;
  font-size: 12px;
  font-weight: bold;
  padding-left: 8px;
  color: var(--bg);
}

::v-deep.draggable {
  margin: -16px;
  max-height: 294px;
  overflow-y: auto;
}
</style>
